export default {
    data: () => ({
        translations: {
            notificationType: {
                el: "Notification Type",
                en: "Notification Type",
                it: "Notification Type"
            },
            total: {
                el: "Ολικό",
                en: "Total",
                it: "Totale"
            },
            date: {
                el: "Ημερομηνία",
                en: "Date",
                it: "Data"
            },
            name: {
                el: "Όνομα",
                en: "Name",
                it: "Nome"
            },
            promotional: {
                el: "Προωθητικό",
                en: "Promotional",
                it: "Promozionale"
            },
            transactional: {
                el: "Συναλλακτικό",
                en: "Transactional",
                it: "Transazionale"
            },
            noData: {
                el: "Δεν υπάρχουν δεδομένα",
                en: "No Data",
                it: "Nessun dato"
            },
        }
    })
};
